import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-632c1710"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "employment" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "EMPLOYMENT", -1))
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, null, -1))
const _hoisted_5 = { style: {"flex":"8"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"11"} }, null, -1))
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, null, -1))
const _hoisted_9 = { style: {"flex":"17"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, reactive } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import CardText from '@/components/CardText.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EmploymentView',
  setup(__props) {

  const router = useRouter();
  const onBack = () => {
    router.back();
    // notify('Back')
  }

  const paragraph = [
    {
      title:'Skill Shortage Assistance',
      data:'1.	Assist Employers experiencing Skills Shortage in Australia to recruited Skill labour overseas under Labour Hire Agreement and Visa 482 or Visa 494 together with our Migration Partners.<br><br>2.	Assist Australian Employers who would like to recruit in the Philippines through POEA Accredited Agents.'
    }
  ];

  const data = reactive(
    {
      paragraph:paragraph
    }
  );

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_page_header, { onBack: onBack })
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(CardText, {
          value: data.paragraph
        }, null, 8, ["value"])
      ]),
      _hoisted_10
    ]),
    _hoisted_11
  ]))
}
}

})